const AdditionalMessageIcon = ({ color = "#303030" }: { color?: string }) => {
    return (
        <svg width="21" height="21" viewBox="0 0 28 22" xmlns="http://www.w3.org/2000/svg" fill={"none"}>
            <path
                d="m20 10.5v-3.7c0-1.68016 0-2.52024-.327-3.16197-.2876-.56449-.7465-1.02343-1.311-1.31105-.6418-.32698-1.4818-.32698-3.162-.32698h-6.4c-1.68016 0-2.52024 0-3.16197.32698-.56449.28762-1.02343.74656-1.31105 1.31105-.32698.64173-.32698 1.48181-.32698 3.16197v10.4c0 1.6802 0 2.5202.32698 3.162.28762.5645.74656 1.0234 1.31105 1.311.64173.327 1.48181.327 3.16197.327h3.2m2-11h-6m2 4h-2m8-8h-8m10 14v-6m-3 3h6"
                stroke={color}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.2"
            />
        </svg>
    );
};

export default AdditionalMessageIcon;
